export const CustomerList = () => ["CustomerList"];
export const CustomerInfo = (id: number | string) => ["CustomerInfo", id];
export const CustomerPlans = (id: any) => ["CustomerPlans", id];
export const UploadCustomerExcelKey = () => ["UploadCustomerExcel"];
export const ExcelFileList = (params: {
  page?: number;
  size?: number;
  sortField?: string;
  sortDirection?: string;
}) => ["ExcelFileList", params];